import TeamServices from '../../services/TeamServices'

const types = {
  GET_EMPLOYEES: '@team/GET_EMPLOYEES'
}

export {
  types as teamTypes
}

export default {
  namespaced: true,
  state: {
    employees: {
      employeeList: [],
      pagingDTO: {
        pageNo: 0,
        pageSize: 20
      }
    }
  },

  getters: {
    employees (state) {
      return state.employees
    }
  },

  mutations: {
    [types.GET_EMPLOYEES] (state, payload) {
      state.employees = payload.employees
    }
  },

  actions: {
    async getEmpoyees ({commit}) {
      const response = await TeamServices.getTeamEmployees({
        companyCode: 1000,
        email: 'jihee.kim@bespinglobal.com',
        leader: 'TEAM',
        pageNo: 1,
        size: 20
      })
      commit(types.GET_EMPLOYEES, {
        employees: response.data.resultData
      })

      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/team.js